import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../../../shared/modal/modal.component';
import { ButtonComponent } from '../../../../../../shared/button/button.component';
import { SidebarService } from '../../../../../../shared/sidebar/sidebar.service';
import { ToastService } from '../../../../../../shared/toast/toast.service';
import { DividerComponent } from '../../../../../../shared/divider/divider.component';
import { InputIconComponent } from '../../../../../../shared/input-icon/input-icon.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { UserService } from '../../../../../../shared/services/user/user.service';
import { toPost } from '../../../../../../models/rest.interface';
import { resetPassword } from '../../../../../../models/user.interface';
import { LoaderService } from '../../../../../../shared/loader/loader.service';
import { ModalService } from '../../../../../../shared/modal/modal.service';

@Component({
  selector: 'app-alterar-senha',
  standalone: true,
  imports: [
    ModalComponent,
    ButtonComponent,
    DividerComponent,
    InputIconComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './alterar-senha.component.html',
  styleUrl: './alterar-senha.component.scss',
})
export class AlterarSenhaComponent implements OnInit {
  camposObrigatoriosSenha: boolean = false;
  haveUppercaseAndLowwercase = false;
  contentNumbers = false;
  specialChars = false;

  form = new FormGroup({
    currentPassword: new FormControl(),
    password: new FormControl(),
    passwordConfirmation: new FormControl(),
  });

  constructor(
    private readonly modalService: ModalService,
    private readonly toast: ToastService,
    private readonly userService: UserService,
    private readonly loaderService: LoaderService,
  ) {}

  ngOnInit(): void {
    this.form.controls.password.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((value) => {
        if (value != null) {
          const containsUppercase = /[A-Z]/.test(value);
          const containsLowercase = /[a-z]/.test(value);
          const containsNumber = /[0-9]/.test(value);
          const containsSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
            value,
          );

          this.contentNumbers = containsNumber;
          this.specialChars = containsSpecial;

          if (containsUppercase && containsLowercase) {
            this.haveUppercaseAndLowwercase = true;
          } else {
            this.haveUppercaseAndLowwercase = false;
          }
        }
      });
  }

  enviar() {
    const password: string = this.form.controls.password.value || '';
    const confirmacaoSenha: string =
      this.form.controls.passwordConfirmation.value || '';
    // Validação de senha
    if (!password || !confirmacaoSenha || !this.form.controls.password.value) {
      this.toast.notify({
        message: 'As senhas não podem estar vazias.',
        type: 'INFO',
      });
      this.camposObrigatoriosSenha = true;
      return;
    }

    if (password !== confirmacaoSenha) {
      this.toast.notify({
        message: 'Senhas informadas não coincidem.',
        type: 'INFO',
      });
      return;
    }

    if (password.length < 8 && confirmacaoSenha.length < 8) {
      this.toast.notify({
        message: 'Preencha a senha corretamente.',
        type: 'INFO',
      });
      return;
    }

    if (!this.haveUppercaseAndLowwercase) {
      this.toast.notify({
        message: 'Preencha a senha corretamente.',
        type: 'INFO',
      });
      return;
    }

    if (!this.contentNumbers) {
      this.toast.notify({
        message: 'Preencha a senha corretamente.',
        type: 'INFO',
      });
      return;
    }
    if (!this.specialChars) {
      this.toast.notify({
        message: 'Preencha a senha corretamente.',
        type: 'INFO',
      });
      return;
    }
    const changePassword: resetPassword = {
      currentPassword: this.form.controls.currentPassword.value,
      password: this.form.controls.password.value,
      passwordConfirmation: this.form.controls.passwordConfirmation.value,
    };
    this.loaderService
      .executeWithLoader(this.userService.alterarSenha(changePassword))
      .subscribe({
        next: () => {
          this.toast.notify({
            message: 'Senha Alterada com Sucesso !',
            type: 'SUCCESS',
          });
          this.modalService.close(true);
        },
        error: () => {
          this.toast.notify({
            message: 'Erro interno ao alterar Senha !',
            type: 'ERROR',
          });
          this.modalService.close(false);
        },
      });
  }

  cancelar() {
    /**
     * Apenas a service do sidebar que estava fechando esta modal
     * o porque ninguém sabe.
     */
    this.modalService.close(false);
  }
}
